import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import ServicesPage from '../pages/services/page';
import GalleryPage from '../pages/gallery/page';
import AboutDoorsPage from '../pages/about-doors/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/usluge',
    element: <ServicesPage />
  },
  {
    path: '/galerija',
    element: <GalleryPage />
  },
  {
    path: '/o-vratima',
    element: <AboutDoorsPage />
  },
  {
    path: '/kontakt',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;